import lodashSet from 'lodash.set';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from 'app/redux/store';
import { questionnairesApi } from 'app/services/questionnaires';
import { resetQuestionnaire } from '../../actions';

export type TSelfEmploymentList = TSelfEmployment[];

export type TSelfEmployment = {
  whoOwnsTheBusiness: Nullable<string>;
  areYouASubscribedBusinessWithAccountantsOnAir: Nullable<string>;
  doesAccountantsOnAirDoYourBookKeepingServices: Nullable<string>;
  currentOrPriorYearWhatBookKeepingSoftwareDidYouUse: Nullable<string>;
  whatIsTheBusinessStructure: Nullable<string>;
  pleaseGiveMoreDetails: Nullable<string>;
  typeOfBusiness: Nullable<string>;
  primaryServiceThatTheBusinessProvides: Nullable<string>;
  doesThisBusinessHaveATaxRegistrationNumber: Nullable<TYesOrNo>;
  businessName: Nullable<string>;
  businessAddress: Nullable<string>;
  haveYouFiledForm8858Or8832InThePast: Nullable<TYesOrNo>;
  grossIncomeFromSelfEmployment: Nullable<string>;
  currency: Nullable<string>;
  uploadDocumentShowingProofOfIncome: Nullable<string>;
  didYouPayPersonalIncomeTaxOnYourSelfEmploymentIncomeDuringTheYearCalendarTaxYearseparateFromSocialSecurity: Nullable<string>;
  amountOfPersonalIncomeTaxOnSelfEmploymentIncome: Nullable<string>;
  wasThisBusinessOperationalAtTheEndOfYear: Nullable<TYesOrNo>;
  doYouWantToListYourBusinessExpenses: Nullable<TYesOrNo>;
  ifYouHaveAnOrganizedbyCategoryExcelSheetWithExpensesPleaseUpload: Nullable<string>;
  doYouHaveAutoExpenses: Nullable<TYesOrNo>;
  isYourOfficeBasedOutOfYourHome: Nullable<TYesOrNo>;
  otherIncome: Nullable<string>;
  inventoryAtTheBeginningOfTheYear: Nullable<string>;
  inventoryAtTheEndOfTheYear: Nullable<string>;
  amountOfPurchasesLessTheCostOfItemsUsedForPersonalUse: Nullable<string>;
  costOfLabordoNotIncludeSalaryPaidToYourself: Nullable<string>;
  materialsAndSupplies: Nullable<string>;
  otherCosts: Nullable<string>;
  advertising: Nullable<string>;
  depreciationAndSection179ExpenseDeductionprovideDepreciationSchedules: Nullable<string>;
  commissionsAndFees: Nullable<string>;
  insuranceotherThanHealth: Nullable<string>;
  interestPaidToBanks: Nullable<string>;
  legalAndProfessionalServices: Nullable<string>;
  officeExpense: Nullable<string>;
  vehiclesMachineryAndEquipment: Nullable<string>;
  otherBusinessProperty: Nullable<string>;
  repairsAndMaintenance: Nullable<string>;
  supplies: Nullable<string>;
  travel: Nullable<string>;
  mealsAndEntertainment: Nullable<string>;
  selfEmploymentHealthInsurancePremium: Nullable<string>;
  wagesPaidToYourEmployees: Nullable<string>;
  otherExpenses: Nullable<string>;
  isThisAUSBusinessOrNonUS: Nullable<TYesOrNo>;
  pleaseUploadTheBusinessRegistrationDocumentFromTheNonUSCountry: Nullable<string>;
  taxRegistrationNumber: Nullable<string>;
  didYouMakeContributionsToASocialSecuritySystemInYourCountryOfResidenceDuringYear: Nullable<TYesOrNo>;
  pleaseProvideTheReason: Nullable<string>;
  pleaseExplain: Nullable<string>;
  autoExpensesAreFrequentlyAuditedDoYouHaveEvidenceToSupportYourDeduction: Nullable<string>;
  carAndTruckExpenses: Nullable<string>;
  whenDidYouPlaceYourVehicleInServiceForBusinessPurpuses: Nullable<string>;
  numberOfMilesUsedOverTheYearForBusiness: Nullable<string>;
  numberOfMilesUsedOverTheYearForOtherPurposes: Nullable<string>;
  wasYourVehicleAvailableForPersonalUseOffDutyHours: Nullable<TYesOrNo>;
  didYouOrYourSpouseHaveAnotherVehicleForPersonalUse: Nullable<TYesOrNo>;
};

export interface SelfEmploymentStateValues {
  selfEmploymentList: TSelfEmploymentList;
}

export interface SelfEmploymentState {
  values: SelfEmploymentStateValues;
}

export const initialState: SelfEmploymentState = {
  values: {
    selfEmploymentList: [
      {
        whoOwnsTheBusiness: null,
        areYouASubscribedBusinessWithAccountantsOnAir: null,
        doesAccountantsOnAirDoYourBookKeepingServices: null,
        currentOrPriorYearWhatBookKeepingSoftwareDidYouUse: null,
        whatIsTheBusinessStructure: null,
        pleaseGiveMoreDetails: null,
        typeOfBusiness: null,
        primaryServiceThatTheBusinessProvides: null,
        doesThisBusinessHaveATaxRegistrationNumber: null,
        businessName: null,
        businessAddress: null,
        haveYouFiledForm8858Or8832InThePast: null,
        grossIncomeFromSelfEmployment: null,
        currency: null,
        uploadDocumentShowingProofOfIncome: null,
        didYouPayPersonalIncomeTaxOnYourSelfEmploymentIncomeDuringTheYearCalendarTaxYearseparateFromSocialSecurity:
          null,
        amountOfPersonalIncomeTaxOnSelfEmploymentIncome: null,
        wasThisBusinessOperationalAtTheEndOfYear: null,
        doYouWantToListYourBusinessExpenses: null,
        ifYouHaveAnOrganizedbyCategoryExcelSheetWithExpensesPleaseUpload: null,
        doYouHaveAutoExpenses: null,
        isYourOfficeBasedOutOfYourHome: null,
        otherIncome: null,
        inventoryAtTheBeginningOfTheYear: null,
        inventoryAtTheEndOfTheYear: null,
        amountOfPurchasesLessTheCostOfItemsUsedForPersonalUse: null,
        costOfLabordoNotIncludeSalaryPaidToYourself: null,
        materialsAndSupplies: null,
        otherCosts: null,
        advertising: null,
        depreciationAndSection179ExpenseDeductionprovideDepreciationSchedules:
          null,
        commissionsAndFees: null,
        insuranceotherThanHealth: null,
        interestPaidToBanks: null,
        legalAndProfessionalServices: null,
        officeExpense: null,
        vehiclesMachineryAndEquipment: null,
        otherBusinessProperty: null,
        repairsAndMaintenance: null,
        supplies: null,
        travel: null,
        mealsAndEntertainment: null,
        selfEmploymentHealthInsurancePremium: null,
        wagesPaidToYourEmployees: null,
        otherExpenses: null,
        isThisAUSBusinessOrNonUS: null,
        pleaseUploadTheBusinessRegistrationDocumentFromTheNonUSCountry: null,
        taxRegistrationNumber: null,
        didYouMakeContributionsToASocialSecuritySystemInYourCountryOfResidenceDuringYear:
          null,
        pleaseProvideTheReason: null,
        pleaseExplain: null,
        autoExpensesAreFrequentlyAuditedDoYouHaveEvidenceToSupportYourDeduction:
          null,
        carAndTruckExpenses: null,
        whenDidYouPlaceYourVehicleInServiceForBusinessPurpuses: null,
        numberOfMilesUsedOverTheYearForBusiness: null,
        numberOfMilesUsedOverTheYearForOtherPurposes: null,
        wasYourVehicleAvailableForPersonalUseOffDutyHours: null,
        didYouOrYourSpouseHaveAnotherVehicleForPersonalUse: null,
      },
    ],
  },
};

const selfEmploymentSlice = createSlice({
  name: 'selfEmployment',
  initialState,
  reducers: {
    update(state, action: PayloadAction<SelfEmploymentStateValues>) {
      state.values = action.payload;
    },
    updateKey(
      state,
      action: PayloadAction<{
        key: keyof SelfEmploymentStateValues | keyof TSelfEmployment;
        value: any;
      }>,
    ) {
      lodashSet(state, `values.${action.payload.key}`, action.payload.value);
    },
    updateFieldArrayKey(
      state,
      action: PayloadAction<{
        key: keyof SelfEmploymentStateValues | keyof TSelfEmployment;
        value: TSelfEmploymentList;
      }>,
    ) {
      const fieldArray = action.payload.value.map((field) => ({
        ...field,
      }));
      if (action.payload.key === 'selfEmploymentList') {
        state.values[action.payload.key] = fieldArray;
      }
    },
  },
  extraReducers: (builder) => {
    builder.addCase(resetQuestionnaire, () => initialState);

    builder.addMatcher(
      questionnairesApi.endpoints.getQuestionnaireById.matchFulfilled,
      (state, { payload }) => {
        state.values = payload.questionnaire.data.taxQuestionnaire
          ? payload.questionnaire.data.taxQuestionnaire.income.selfEmployment
              .values
          : initialState.values;
      },
    );
  },
});

export const { update, updateKey, updateFieldArrayKey } =
  selfEmploymentSlice.actions;
export default selfEmploymentSlice.reducer;

export const selectSelfEmployment = (state: RootState) =>
  state.taxQuestionnaire.income.selfEmployment;
